import { useSelector } from 'react-redux';
import { _ } from '/@/locale';
import { getAppInstance, getCornRecommendationEnabled, getSoyRecommendationEnabled } from '/@/store/session/selectors';

const useOverlayConfig = () => {
    const actualAppInstance = useSelector((state) => getAppInstance(state));
    const enableSoyRecommendation = useSelector((state) => getSoyRecommendationEnabled(state, actualAppInstance));
    const enableCornRecommendation = useSelector((state) => getCornRecommendationEnabled(state, actualAppInstance));
    const isOffline = useSelector((state) => state.network.offline);
    let overlayConfig = [
        {
            label: _('Recomendación de Maíz'),
            icon: 'corn',
            color: 'orange',
            enable: enableCornRecommendation && !isOffline,
            type: 'corn',
            id: 'cornReco',
        },
        {
            label: _('Recomendación de Soja'),
            icon: 'soy',
            color: 'green',
            enable: enableSoyRecommendation,
            type: 'soy',
            id: 'soyReco',
        },
    ];
    overlayConfig = overlayConfig.filter(
        (oc) =>
            (oc.type === 'corn' && enableCornRecommendation && !isOffline) ||
            (oc.type === 'soy' && enableSoyRecommendation)
    );
    return overlayConfig;
};

export default useOverlayConfig;
